import logo from "../assets/MMMFundLogo.png";
import notification from "../assets/notification.png"

export default function Header() {
  return (
    <header className="header">
      <img src={logo} className="logo" />
    </header>
  );
}